export * from './identificador.service';
export * from './avaliacao.service';
export * from './categoria.service';
export * from './questao.service';
export * from './referencia.service'
export * from './colecao.service'
export * from './aplicacao.service';
